import { NgStyle } from '@angular/common';
import { afterNextRender, ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';

import type { ButtonConfig } from '@shared/components/button/button.model';
import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';

import { type TaskCardConfig } from './task-card.types';

@Component({
  selector: 'app-task-card',
  templateUrl: './task-card.html',
  imports: [Dynamic, NgStyle],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskCard {
  readonly config = input.required<TaskCardConfig>();
  readonly disabled = input<boolean>(false);
  readonly buttonClick = output<DynamicAction>();

  protected readonly backgroundStyle = signal<Record<string, string>>({});

  protected readonly buttonConfig = computed<ButtonConfig | undefined>(() => {
    const btn = this.config().button;
    if (!btn) return undefined;
    return { rounded: true, size: 'small' as const, ...btn };
  });

  constructor() {
    afterNextRender(() => {
      const gradient = getComputedStyle(document.documentElement)
        .getPropertyValue('--taskcard-background-gradient')
        .trim();

      if (gradient) {
        this.backgroundStyle.set({
          background: `linear-gradient(180deg, var(--gradients-${gradient}-start), var(--gradients-${gradient}-middle), var(--gradients-${gradient}-stop))`,
        });
      } else {
        this.backgroundStyle.set({ background: 'var(--taskcard-background)' });
      }
    });
  }

  protected onButtonClick(event: DynamicAction): void {
    this.buttonClick.emit(event);
  }
}
